module.exports = __webpack_public_path__ + "static/media/hercules-son-of-zeus.d2d32029.gif";